import { Component, Input, EventEmitter, SimpleChanges, OnChanges, Output } from '@angular/core';
import { TranslateService } from '@devinforius/i-essentials';
import { ContactsService } from 'src/app/shared/services/contacts.service';
import { ContactDto } from 'src/app/shared/interfaces';
import { GroupsMembers } from 'src/app/shared/models/iContact/global/groups-members';
import { UserService } from 'src/app/shared/models/iCourrier/me/user-service';
import { RightMail } from 'src/app/shared/models/iCourrier/right/right-mail';
import { RightManagement } from 'src/app/shared/models/iCourrier/right/right-management';
import { ServiceChildParent } from 'src/app/shared/models/iCourrier/service';
import { WorkflowsRightMails } from 'src/app/shared/models/workflows/right-mails';
import { ConfigDto } from 'src/app/shared/interfaces/config';
import { ContactsGlobalService } from 'src/app/shared/services/contacts-global.service';
import { Router } from '@angular/router';

import * as _ from 'underscore';
import { WorkflowInstance, WorkflowInstanceDTO } from 'src/app/shared/models/workflows/workflow-instance';
import { WorkflowsService } from 'src/app/shared/services/workflows.service';
import { Tags } from 'src/app/shared/models/iCourrier/tags/tags';
import { TagsCourrier } from 'src/app/shared/models/iCourrier/tags/tags-courrier';
import { MailDetails } from 'src/app/shared/models/mails/mail-details-dto.';
import { NgxSpinnerService } from 'ngx-spinner';
import { Source } from 'src/app/shared/models/iCourrier/source';
import { IButtonMenuItem } from '@devinforius/i-essentials/lib/models/i-button-menuitem';

@Component({
  selector: 'app-courrier-details-general-infos',
  templateUrl: './courrier-details-general-infos.component.html',
  styleUrls: ['./courrier-details-general-infos.component.scss'],
})

// page affichant les infos d'un courrier sous la forme d'un accordéon
export class CourrierDetailsGeneralInfosComponent implements OnChanges {
  @Input() courrier: MailDetails;
  @Input() sourceList: Source[] = []; //need to be send just like the backend sends it => with id and description
  @Input() natureList = []; // need the whole natureList. With all the datas for complementary datas
  @Input() configuration: ConfigDto = null;
  @Input() tags: Tags[] = [];
  @Input() tagsCourrier: TagsCourrier[] = [];
  @Input() rightFlux: WorkflowsRightMails;
  @Input() rightMail: RightMail;
  @Input() rightManagement: RightManagement;
  @Input() userServices: UserService[];
  @Input() readonly = false;
  @Input() servicesChildParent: ServiceChildParent[];
  @Input() groupsMemberUserConnected: GroupsMembers[] = [];

  @Output() openiBacEmitter = new EventEmitter<void>();
  @Output() addTagsEmitter = new EventEmitter<number[]>();
  @Output() deleteTagsEmitter = new EventEmitter<TagsCourrier>();
  @Output() createTagEmitter = new EventEmitter<boolean>();

  @Output() cancelWorkflowInstanceEmitter = new EventEmitter<void>();
  @Output() deleteWorkflowInstanceEmitter = new EventEmitter<void>();
  @Output() resumeWorkflowInstanceEmitter = new EventEmitter<void>();
  @Output() retryFaultedWorkflowInstanceEmitter = new EventEmitter<void>();

  public showRefRecommanded: boolean = false;
  public displayEtiquetteAdd: boolean = false;
  public hideTags: boolean = true;
  public tagsAllowedToBeAdded: Tags[] = [];
  public tagsModel: number[] = [];
  public senderTooltip: string;

  public bacTabSelected: boolean = false;

  public displayFlowButtons: boolean = false;
  public flowButtons: IButtonMenuItem[] = [];

  constructor(
    private contactsService: ContactsService,
    private translater: TranslateService,
    private router: Router,
    private contactsGlobalService: ContactsGlobalService,
    private workflows: WorkflowsService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.flowButtons = [];
    if (this.rightFlux?.canResumeWorkflowInstance) {
      this.flowButtons.push({
        label: this.translater.translate('courrierFiche.resumeFlow'),
        icon: 'bi bi-arrow-clockwise icon--green',
        click: () => {
          this.resumeWorkflowInstance();
        },
      });
    }
    if (this.rightFlux?.canRetryFaultedWorkflowInstance) {
      this.flowButtons.push({
        label: this.translater.translate('courrierFiche.retryFaultedFlow'),
        icon: 'bi bi-arrow-repeat icon--orange',
        click: () => {
          this.retryFaultedWorkflowInstance();
        },
      });
    }
    if (this.rightFlux?.canCancelWorkflowInstance) {
      this.flowButtons.push({
        label: this.translater.translate('courrierFiche.cancelRunningFlow'),
        icon: 'bi bi-sign-stop-fill icon--red',
        click: () => {
          this.cancelWorkflowInstance();
        },
      });
    }
    if (this.rightFlux?.canDeleteWorkflowInstance) {
      this.flowButtons.push({
        label: this.translater.translate('courrierFiche.deleteFlow'),
        icon: 'bi bi-trash3-fill icon--red',
        click: () => {
          this.deleteWorkflowInstance();
        },
      });
    }

    if (this.flowButtons.length) this.displayFlowButtons = true;

    if (this.sourceList?.length > 0 && this.courrier?.sourceId) {
      //ici on va faire 2 choses :
      // 1) setter le label de la source du courrier
      this.courrier.source = this.sourceList.find((x) => x.id === this.courrier.sourceId)?.description;

      //2) on va setter l'affichage référence recommandé
      const currentSource = this.sourceList.filter((x) => x.id === this.courrier.sourceId);
      if (currentSource.length > 0) {
        this.showRefRecommanded = currentSource[0]['afficherReferenceRecommande'];
      }
    }
    if (this.natureList?.length && this.courrier?.nature?.id) {
      this.courrier.nature = this.natureList.find((x) => x.id === this.courrier.nature.id);
      this.courrier.natureCustomDatas = this.courrier.natureCustomDatas.filter((x) => x.id);
    }
    if (changes.courrier && changes.courrier.currentValue?.id && (this.courrier.expediteurIdiAdmin || this.courrier.expediteurId)) {
      this.contactsService
        .fetchContact(this.courrier.expediteurIdiAdmin ?? this.courrier.expediteurId, this.courrier.expediteurIdiAdmin ? 'iAdmin' : 'iCourrier')
        .subscribe({
          next: (res: ContactDto) => {
            this.courrier.expediteurFull = res;
            if (this.courrier.expediteurFull?.typeContactId) {
              this.contactsGlobalService.fetchContactTypes([this.courrier.expediteurFull?.typeContactId]).subscribe({
                next: (res) => {
                  this.courrier.expediteurFull.typeContactLabel = res[0].typeContact;
                  this.getSenderTooltip();
                },
              });
            } else {
              this.getSenderTooltip();
            }
          },
        });
    }
    if (this.servicesChildParent?.length > 0 && this.courrier?.priseEnChargeInfo) {
      // Ici on va récupérer le nom du service de la prise en charge
      this.courrier.priseEnChargeInfo.serviceLabel = this.servicesChildParent.find(
        (x) => x.id === this.courrier.priseEnChargeInfo.serviceId
      ).description;
    }
    if (this.userServices?.length > 0 && this.courrier?.serviceProprietaireId) {
      this.hideTags = this.userServices.find((userService) => userService.serviceId === this.courrier.serviceProprietaireId)?.cacherStatutsMultiples;
    }
    if (this.tags?.length > 0 && this.courrier?.serviceProprietaireId) {
      this.tagsAllowedToBeAdded = [];
      /* 
        ICOUR-4148
        Ici on va récupérer uniquement les tags qui correspondent aux droits d'ajouts : (attention les conditions numérotées sont liées avec des ET)
        1) L'étiquette est utilisable
        2) L'étiquette n'a pas de groupe permettant de la lier || l'étiquette a un ou plusieurs groupes MAIS l'utilisateur est membre d'un de ces groupes
        3) L'étiquette n'a pas de service || l'étiquette a un ou plusieurs services MAIS le service du courrier correspond à un de ces groupes
      */
      this.tags.forEach((tag) => {
        //* vérification si un user peut cocher et lier une étiquette
        const isUsable = !tag.notUsed;

        //! il faut que dans le compo' parent on ait les infos de notUsed, courrierActionDroitCocherGroupeID et servicesAuthorized => Voir comment on a fait dans courrier-fiche-form :)

        const isTagCheckGroupOk =
          !tag.courrierActionDroitCocherGroupeID ||
          this.groupsMemberUserConnected.some((group) => group.groupe.id === tag.courrierActionDroitCocherGroupeID);

        const isTagServiceOk =
          tag.servicesAuthorized?.length === 0 ||
          (tag.servicesAuthorized?.length > 0 && tag.servicesAuthorized.includes(this.courrier.serviceProprietaireId));

        // Lorsque l'on possède ces trois droits, c'est que le tag peut être ajouté au mail
        //
        if (isUsable && isTagCheckGroupOk && isTagServiceOk) {
          this.tagsAllowedToBeAdded.push(tag);
          if (tag.isNewlyCreated) {
            this.tagsModel.push(tag.value);
          }
        }
      });
    }
    if (this.tagsCourrier?.length > 0) {
      //* Vérification si un user peut décocher et délier une étiquette :)
      //! Il faut que dans le compo' parent on ait l'info de courrierActionDroitDecocherGroupeID => Voir comment on a fait dans courrier-fiche-form :)
      this.tagsCourrier = this.tagsCourrier.map((tag) => {
        // On va enlever les étiquettes déjà ajoutées au courrier. On arrive ici quand
        // 1) on affiche la fiche courrier
        // 2) quand on a ajouté une étiquette à la fiche courrier
        //! subtilité dans les tagsCourrier le statusId c'est en fait lié à l'id de this.tags.id => voir this.multipleStatutesService.getMailMultipleStatutes
        const index = this.tagsModel.indexOf(tag.statusId);
        if (index > -1) {
          this.tagsModel.splice(index, 1);
        }

        tag.canUncheck =
          !tag.courrierActionDroitDecocherGroupeID ||
          (tag.courrierActionDroitDecocherGroupeID &&
            this.groupsMemberUserConnected.map((group) => group.groupe.id).includes(tag.courrierActionDroitDecocherGroupeID));

        return tag;
      });
      this.tagsCourrier = [...this.tagsCourrier];
    }
  }

  addTags(tagsToAdd: number[]): void {
    this.addTagsEmitter.emit(tagsToAdd);
  }

  deleteTags(event: TagsCourrier): void {
    this.deleteTagsEmitter.emit(event);
  }

  createTag(): void {
    this.createTagEmitter.emit(true);
  }

  getOppositeColor(bgColor): string {
    if (bgColor) {
      const color = bgColor.charAt(0) === '#' ? bgColor.substring(1, 7) : bgColor;
      const r = parseInt(color.substring(0, 2), 16); // hexToR
      const g = parseInt(color.substring(2, 4), 16); // hexToG
      const b = parseInt(color.substring(4, 6), 16); // hexToB
      return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? '#000000' : '#FFFFFF';
    } else {
      return '#000000';
    }
  }

  openIbacSidebar(event): void {
    event.preventDefault();
    event.stopPropagation();
    this.openiBacEmitter.emit();
  }

  getSenderTooltip(): void {
    let address = this.translater.translate('address') + ' : ';
    if (this.courrier?.expediteurFull?.adressePrincipale) {
      address +=
        (this.courrier.expediteurFull.adressePrincipale.impression_Adresse
          ? this.courrier.expediteurFull.adressePrincipale.impression_Adresse + ' '
          : '') +
        (this.courrier.expediteurFull.adressePrincipale.impression_CodePostal
          ? this.courrier.expediteurFull.adressePrincipale.impression_CodePostal + ' '
          : '') +
        (this.courrier.expediteurFull.adressePrincipale.impression_Localite
          ? this.courrier.expediteurFull.adressePrincipale.impression_Localite
          : '');
    } else {
      address += '/';
    }
    let tel = this.translater.translate('phone') + ' : ';
    if (this.courrier?.expediteurFull?.adressePrincipale?.gsm) {
      tel += this.courrier.expediteurFull.adressePrincipale.gsm ? this.courrier.expediteurFull.adressePrincipale.gsm : '';
    } else {
      tel += '/';
    }

    let type = this.translater.translate('contactType') + ' : ';
    if (this.courrier?.expediteurFull?.typeContactId) {
      type += this.courrier.expediteurFull.typeContactLabel;
    } else {
      tel += '/';
    }

    this.senderTooltip = `${address}
    ${tel}
    ${type}`;
  }

  sendAdvancedSearchInfos(addBinder: boolean, addFolder: boolean): void {
    let data: { SvcPropIds: number[]; ClassementIds: number[]; ClasseurId?: number; ChemiseId?: number } = {
      SvcPropIds: [this.courrier.serviceProprietaireId],
      ClassementIds: [this.courrier.classement.id],
      ClasseurId: addBinder ? this.courrier.classeur.id : null,
      ChemiseId: addFolder ? this.courrier.chemise.id : null,
    };
    data = this.cleanObject(data);

    sessionStorage.setItem('searchData', JSON.stringify(data));

    const queryParams = Object.keys(data)
      .map((key) => {
        if (_.isArray(data[key])) {
          return `${key}=${data[key].toString()}`;
        } else {
          return `${key}=${data[key]}`;
        }
      })
      .join('&');

    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/private/ic/courriers/advancedSearch'], {
        queryParams: {
          advancedSearchData: queryParams,
        },
      })
    );
    window.open(url, '_blank');
  }

  cleanObject(object): { SvcPropIds: number[]; ClassementIds: number[]; ClasseurId?: number; ChemiseId?: number } {
    const propNames = Object.getOwnPropertyNames(object);
    for (let i = 0; i < propNames.length; i++) {
      const propName = propNames[i];
      if (object[propName] === null || object[propName] === undefined || object[propName] === '') {
        delete object[propName];
      }
    }
    return object;
  }

  public openContactDetails(): void {
    window.open('/private/ic/contacts/details/' + this.courrier.expediteurId, '_blank');
  }

  public getTooltipFlow(index: number): string {
    return this.courrier.workflowForInfosArray[index].definitionVersion.description
      ? this.courrier.workflowForInfosArray[index].definitionVersion.description
      : this.courrier.workflowForInfosArray[index].definitionVersion.name;
  }

  public cancelWorkflowInstance(): void {
    this.spinner.show();
    this.cancelWorkflowInstanceEmitter.emit();
  }
  public deleteWorkflowInstance(): void {
    this.spinner.show();
    this.deleteWorkflowInstanceEmitter.emit();
  }
  public resumeWorkflowInstance(): void {
    this.spinner.show();
    this.resumeWorkflowInstanceEmitter.emit();
  }

  public retryFaultedWorkflowInstance(): void {
    this.spinner.show();
    this.retryFaultedWorkflowInstanceEmitter.emit();
  }

  public onOpenFlowTab(event): void {
    if (event && this.courrier.workflowId) {
      this.courrier.workflowForInfosArray = [];
      this.workflows.getWorkflowId(this.courrier.id, this.courrier.workflowId).subscribe({
        next: (res: WorkflowInstanceDTO) => {
          this.courrier.workflowForInfosArray.push(new WorkflowInstance(res));
        },
      });
    }
  }
}
